module.exports = __webpack_public_path__ + "static/media/bike_black_48px.85b59d20.svg";


//////////////////
// WEBPACK FOOTER
// ./src/bike_black_48px.svg
// module id = 1224
// module chunks = 0